export default "__VITE_ASSET__CZXhXjPf__"